const gravatarImg = (firstname, lastname) => {
  return `https://ui-avatars.com/api/?name=${firstname}+${lastname}`;
};

export default gravatarImg;
